import { Stack, Typography, Box } from "@mui/material";
import dayjs from "dayjs";
import { getColorByDate, SlotsAvlMap } from "../services/entity";
var CalendarDateHeader = function (_ref) {
    var _SlotsAvlMap$dayjs$fo;
    var label = _ref.label, isOffRange = _ref.isOffRange, date = _ref.date;
    return /*#__PURE__*/ React.createElement(Stack, {
        alignItems: "flex-end"
    }, /*#__PURE__*/ React.createElement(Typography, {
        color: isOffRange ? 'text.tertiary' : 'text.secondary'
    }, label), /*#__PURE__*/ React.createElement(Box, {
        borderRadius: 1,
        height: 4,
        ml: "5px",
        mb: 0.5,
        width: "".concat(((_SlotsAvlMap$dayjs$fo = SlotsAvlMap[dayjs(date).format('DD-MM-YYYY')]) !== null && _SlotsAvlMap$dayjs$fo !== void 0 ? _SlotsAvlMap$dayjs$fo : 0) * 10, "%"),
        bgcolor: getColorByDate(date)
    }));
};
export default CalendarDateHeader;
